import { NARROW_STAGE_QUERY } from '../../shared/narrow_stage.js';

/**
 * O degrau do palco ESTREITO do hotel, compartilhado pela barra de busca, pelo
 * palco de resultado e pela página determinística: abaixo dele a barra da
 * conversa vira pílula-resumo + folha (`hotel_search_sheet.tsx`), o palco de
 * resultado troca de pele (`hotel_results.tsx`, #2671) e a página de
 * resultados e o mapa cheio trocam a faixa de mapa e o voltar pelo botão
 * flutuante Lista↔Mapa (`hotel_results_page.tsx`, `hotel_map_fullscreen.tsx`,
 * #2665). É a régua `sm` do DS (640), o degrau de componente, que cobre os dois
 * palcos estreitos reais: o WebView do celular (360–390) e o iframe do host web
 * no desktop (480).
 *
 * Um dono só: os consumidores têm de virar na MESMA largura, senão há uma
 * faixa em que o resultado esconde a barra achando que ela é pílula enquanto
 * ela ainda é a fileira larga.
 */
export const HOTEL_NARROW_QUERY = NARROW_STAGE_QUERY;
